export const STATUS_STYLES = {
  won: {
    bg: "bg-[#11A306]/20",
    text: "text-[#11A306]",
    border: "border-[#11A306]",
  },
  lost: {
    bg: "bg-[#ec3737]/20",
    text: "text-[#ec3737]",
    border: "border-[#ec3737]",
  },
  pending: {
    bg: "bg-yellow/20",
    text: "text-yellow",
    border: "border-yellow",
  },
  cancelled: {
    bg: "bg-doubleextralightwhite/20",
    text: "text-doubleextralightwhite",
    border: "border-doubleextralightwhite",
  },
};
